(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-media-gallery"] && !Shopify.designMode) return;
  try {
    // Hover/touch on product card: go to image 2 in slider
  document.addEventListener('DOMContentLoaded', function() {
    function initHoverSlider(gallery) {
      const sliderComponent = gallery.querySelector('slider-component');
      if (!sliderComponent) return;
      
      let splide = null;
      let hoverTimer = null;
      
      function getSplide() {
        if (!splide) {
          splide = sliderComponent._splide || (sliderComponent.splide);
        }
        return splide;
      }
      
      function goToSecond() {
        const sp = getSplide();
        if (sp && sp.length > 1) {
          sp.go(1);
        } else {
          // Try via DOM: click the second slide indicator or use splide API
          const track = sliderComponent.querySelector('.splide__track');
          if (track) {
            const list = track.querySelector('.splide__list');
            if (list) {
              list.style.transition = 'transform 0.4s ease';
              list.style.transform = 'translateX(-100%)';
            }
          }
        }
      }
      
      function goToFirst() {
        const sp = getSplide();
        if (sp && sp.length > 1) {
          sp.go(0);
        } else {
          const track = sliderComponent.querySelector('.splide__track');
          if (track) {
            const list = track.querySelector('.splide__list');
            if (list) {
              list.style.transition = 'transform 0.4s ease';
              list.style.transform = 'translateX(0)';
            }
          }
        }
      }
      
      const card = gallery.closest('product-card') || gallery.closest('.product-card');
      const target = card || gallery;
      
      // Desktop: mouseenter/mouseleave
      target.addEventListener('mouseenter', function() {
        hoverTimer = setTimeout(goToSecond, 0);
      });
      target.addEventListener('mouseleave', function() {
        clearTimeout(hoverTimer);
        goToFirst();
      });
      
      // Mobile: touchstart to go to second, touchend to go back
      target.addEventListener('touchstart', function() {
        goToSecond();
      }, { passive: true });
      target.addEventListener('touchend', function() {
        setTimeout(goToFirst, 800);
      }, { passive: true });
    }
    
    function initAll() {
      document.querySelectorAll('product-card-media-gallery').forEach(function(gallery) {
        if (!gallery.dataset.hoverSliderInit) {
          gallery.dataset.hoverSliderInit = '1';
          initHoverSlider(gallery);
        }
      });
    }
    
    initAll();
    // Re-init for dynamically loaded cards
    const observer = new MutationObserver(initAll);
    observer.observe(document.body, { childList: true, subtree: true });
  });
  } catch(e) { console.error(e); }
})();

})();
